module.exports = __webpack_public_path__ + "img/user-img.f13da004.png";